export default {
  ApplicationInfo: 'Information',
  Game: 'Game',
  Account: 'Account',
  Server: 'Server',
  CharacterName: 'Character Name',
  PlatformOrderNumber: 'Platform Order Number',
  Amount: 'Amount',
  InvoiceMethod: 'Invoice Details',
  InvoiceByTotalOrderAmount:
    'Issue an invoice according to the total amount of multiple orders',
  InvoiceByOrderAmountSeparately:
    'Issue separate invoices for multiple orders based on the amount of each order',
  PhoneNumber: 'Contact Number',
  Name: 'Name',
  Address: 'Address',
  InvoiceTitle: 'Invoice to',
  PersonalTitleOnlyNoCompany:
    'Please enter your name. Do not enter the name of a company or organization.',
  ReceivingEmail: 'Email',
  Remarks: 'Note',
  InputContent: 'Input here',
  ApplicationSubmittedSuccessfully: 'Application Submitted',
  InvoiceApplicationSubmittedSuccessfully:
    'Your invoice application has been submitted. \r\nOur team will process it within 7 business days, please check your email.',
  Confirm: 'Confirm',
  Submit: 'Submit',
  ApplicationSubmissionFailed: 'Failed to submit application',
  InvoiceApplicationFailed:
    'Your invoice application has not been submitted. Please refresh and try again or contact customer service.',
  InvoiceApplicationSubmitted:
    'Your application has been submitted. Please do not submit it again.',
  PleaseEnterName: 'Please enter name',
  PleaseEnterAddress: 'Please enter address',
  PleaseEnterInvoiceTitle: 'Please enter recipient name',
  PleaseEnterEmail: 'Please enter email address',
  PleaseEnterRemarks: 'Please enter a note if needed',
  NumberParsingError: 'Invalid number',
  PleaseEnterValidEmailFormat: 'Please enter a valid email',
  IncompleteInformation: 'Information incomplete, please check',
  ExpandAll: 'Show All'
};
